import { render, staticRenderFns } from "./TableCheckbox.vue?vue&type=template&id=f284aae4"
import script from "./TableCheckbox.vue?vue&type=script&lang=ts"
export * from "./TableCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports